export default __webpack_public_path__ + "static/media/featured_area_windsor.ce7fb4a9.webp";